module.exports = __webpack_public_path__ + "img/390298a.png";